var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiftCardLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.97 9.99982H3.97V17.9998C3.97 20.9998 4.97 21.9998 7.97 21.9998H15.97C18.97 21.9998 19.97 20.9998 19.97 17.9998V9.99982ZM21.5 6.99982V7.99982C21.5 9.09982 20.97 9.99982 19.5 9.99982H4.5C2.97 9.99982 2.5 9.09982 2.5 7.99982V6.99982C2.5 5.89982 2.97 4.99982 4.5 4.99982H19.5C20.97 4.99982 21.5 5.89982 21.5 6.99982ZM11.64 4.99982H6.12C5.95557 4.82148 5.8668 4.58627 5.8724 4.34376C5.87799 4.10125 5.97752 3.87038 6.15 3.69982L7.57 2.27982C7.74972 2.10211 7.99226 2.00244 8.245 2.00244C8.49774 2.00244 8.74028 2.10211 8.92 2.27982L11.64 4.99982ZM17.87 4.99982H12.35L15.07 2.27982C15.2497 2.10211 15.4923 2.00244 15.745 2.00244C15.9977 2.00244 16.2403 2.10211 16.42 2.27982L17.84 3.69982C18.2 4.05982 18.21 4.62982 17.87 4.99982Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93994 10V15.14C8.93994 15.94 9.81994 16.41 10.4899 15.98L11.4299 15.36C11.5932 15.2525 11.7844 15.1952 11.9799 15.1952C12.1754 15.1952 12.3667 15.2525 12.5299 15.36L13.4199 15.96C13.5701 16.0601 13.7447 16.1176 13.9249 16.1263C14.1052 16.135 14.2845 16.0945 14.4436 16.0093C14.6027 15.9241 14.7357 15.7973 14.8284 15.6425C14.9211 15.4876 14.97 15.3105 14.9699 15.13V10H8.93994Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftCardLight);
export default __webpack_public_path__ + "static/media/gift-card-light.7359b8542dd33a1be3c8ae150d20671c.svg";
export { ForwardRef as ReactComponent };